module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": "",
      "pa-0": _vm.$vuetify.breakpoint.xsOnly
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "color": "grey lighten-4"
    }
  }, [_c('v-card-text', [_c('h4', {
    staticClass: "title mb-2"
  }, [_vm._v("Curso")]), _vm._v(" "), _c('div', {
    staticClass: "subheading"
  }, [_c('v-chip', {
    staticClass: "white--text",
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.dadosMatricula.matricula.contrato.descricao) + "\n                        ")]), _vm._v(" "), _c('v-chip', {
    staticClass: "white--text",
    attrs: {
      "color": "secondary"
    }
  }, [_vm._v(_vm._s(_vm.dadosMatricula.matricula.descricao))]), _vm._v(" "), (_vm.dadosMatricula.matricula.temPreencherPolo) ? _c('v-chip', {
    staticClass: "white--text",
    attrs: {
      "color": "info"
    }
  }, [_vm._v("\n                          POLO " + _vm._s(_vm.dadosMatricula.matricula.polos.find(function (p) { return p.id === _vm.dadosMatricula.matricula.ref_polo; }).descricao) + "\n                        ")]) : _vm._e()], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-4 mb-4"
  }), _vm._v(" "), _c('div', [_c('h4', {
    staticClass: "title mb-2"
  }, [_vm._v("Disciplinas ¹")]), _vm._v(" "), _vm._l((_vm.disciplinasSemCpp), function(disciplina) {
    return _c('v-chip', {
      attrs: {
        "color": "primary",
        "outline": ""
      }
    }, [_c('span', {
      staticClass: "disciplina"
    }, [_vm._v(_vm._s(disciplina.descricao))])])
  }), _vm._v(" "), (_vm.dadosMatricula.matricula.contrato.cpp.descricao) ? _c('v-chip', {
    attrs: {
      "color": "primary",
      "outline": ""
    }
  }, [_c('span', {
    staticClass: "disciplina"
  }, [_vm._v(_vm._s(_vm.dadosMatricula.matricula.contrato.cpp.descricao) + " ("), _c('strong', [_vm._v("*CPP")]), _vm._v(")")])]) : _vm._e()], 2), _vm._v(" "), (_vm.dadosMatricula.matricula.incentivos.length) ? _c('div', [_c('v-divider', {
    staticClass: "mt-4 mb-4"
  }), _vm._v(" "), _c('h4', {
    staticClass: "title mb-2"
  }, [_vm._v("Incentivos ²")]), _vm._v(" "), _vm._l((_vm.dadosMatricula.matricula.incentivos), function(item) {
    return _c('v-chip', {
      attrs: {
        "color": "primary",
        "outline": ""
      }
    }, [_c('span', {
      staticClass: "disciplina"
    }, [_vm._v(_vm._s(item))])])
  })], 2) : _vm._e(), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-4 mb-4"
  }), _vm._v(" "), _c('div', [_c('h4', {
    staticClass: "title mb-3"
  }, [_vm._v("Pagamento ² ³")]), _vm._v(" "), (_vm.dadosMatricula.matricula.parcelas) ? _c('div', {
    staticClass: "title font-weight-light"
  }, [_vm._l((_vm.dadosMatricula.matricula.parcelas.detalhes), function(item) {
    return (_vm.dadosMatricula.matricula.parcelas.quantidade > 1) ? [(item.numeroParcela == 1) ? _c('span', [_vm._v(" " + _vm._s(item.numeroParcela) + "x de R$ " + _vm._s(_vm._f("currencyEnToBr")(item.valorUnitario)) + " + " + _vm._s(_vm.dadosMatricula.matricula.parcelas.quantidade - 1) + "x de R$ " + _vm._s(_vm._f("currencyEnToBr")(_vm.dadosMatricula.matricula.parcelas.valor)))]) : _vm._e()] : _vm._e()
  }), _vm._v(" "), (_vm.dadosMatricula.matricula.parcelas.quantidade == 1) ? [_vm._v("\n                            " + _vm._s(_vm.dadosMatricula.matricula.parcelas.quantidade) + "x de R$ " + _vm._s(_vm._f("currencyEnToBr")(_vm.dadosMatricula.matricula.parcelas.valor)) + "\n                          ")] : _vm._e()], 2) : _vm._e()]), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-4 mb-4"
  }), _vm._v(" "), _c('div', [_c('h4', {
    staticClass: "title mb-3"
  }, [_vm._v("Mensagens Importantes")]), _vm._v(" "), _c('div', [_c('p', [_vm._v("¹ Após a confirmação da matrícula não será permitida a troca da disciplina escolhida na CPP (Ignore se você não selecionou nenhuma);")]), _vm._v(" "), _c('p', [_vm._v("² Caso alguma informação estiver incorreta, ou vocẽ tenha alguma dúvida, não conclua esta etapa e dirija-se à Central de Atendimento do seu Câmpus;")]), _vm._v(" "), (_vm.dadosMatricula.matricula.intencaoVaga.intencao) ? _c('p', [_vm._v("³ Não esqueça, esse é um pagamento de Intenção de Vaga")]) : _c('p', [_vm._v("³ Verifique os valores dos descontos de pontualidade na mensagem dos boletos;")])])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-header"
  }, [_c('navigation-buttons', {
    attrs: {
      "show-previous": true,
      "show-next": true,
      "previous-click": _vm.voltar,
      "next-click": _vm.salvarDados,
      "disable-next": _vm.$v.dadosMatricula.$invalid,
      "confirm": true
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-470ab958!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/dashboard/matricula_online/Confirmacao.vue
// module id = 539
// module chunks = 2